import React, { useState, useEffect } from 'react';
import Plot from "react-plotly.js";
import useClientStore from '../stores/client';
import Pako from 'pako';

const HrvDash = (props) => {
  const offset = 1300;
  const { client, addOnMessage, removeOnMessage } = useClientStore();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [data, setData] = useState([]);
  const [graphData, setGraphData] = useState({});
  const [graphLayout, setGraphLayout] = useState({
        autosize: true,
        xaxis: { 
           showgrid: true, zeroline: false, showticklabels: false,
           dtick: 0.25, gridcolor: 'rgba(221,221,221,0.2)',
           range: [-1.7, 12.3]
          },
        yaxis: {
          showgrid: true, zeroline: false, showticklabels: false,
          gridcolor: 'rgba(221,221,221,0.2)',
          dtick: offset / 4,
          range: [-1500, 7 * 3000]
         },
        margin: { l: 0, r: 0, t: 0, b: 0 },
        showlegend: false,
        // rgba(34, 54, 91,1)
        plot_bgcolor: '#000000',  // Set the plot background color to black
        paper_bgcolor: 'white',  // Set the paper background color to black
        font: { color: 'red' }, // Set font color to white for better contrast
        annotations: []
      });
  let cTopic = '';

  useEffect(()=> {
    const data = props.data;
    setData(data);
  }, [props.data]);

  useEffect(()=> {
      if(data){
        if (client && isSubscribed === false) {
          cTopic = `aw/${data.device_sn}/stream/hrv`;
          client.subscribe(cTopic, (error) => {
            if (error) {
              console.log("Subscribe to topics error", error);
              setIsSubscribed(false);
              return;
            } else {
              console.log(`Successfully subscribed to ${cTopic}`);
              setIsSubscribed(true);
            }
          });
        }

        addOnMessage(cTopic, onMessage);
      }
  }, [data]);

  useEffect(() => {
      return () => {
        // 컴포넌트 언마운트 시 구독 해제
        if (client) {
          client.unsubscribe(cTopic, (error) => {
            if (error) {
              console.log("Unsubscribe error", error);
            }
          });
        }
        removeOnMessage(cTopic, onMessage);
      };
  }, []);

  const onMessage=(topic, message) => {
    if (cTopic !== topic) {
        return;
    }

    // Base64 디코딩
      let decompressMessage = null;

    try {
      const compressedData = Uint8Array.from(atob(message), c => c.charCodeAt(0));
      decompressMessage = Pako.inflate(compressedData, {to: 'string'});
    } catch(error) {
      decompressMessage = Pako.inflate(message, {to: 'string'});
    }

    const parsedMessage = JSON.parse(decompressMessage);
    if (parsedMessage.hasOwnProperty("timestamp")){
        procData(data, parsedMessage.data);
    } else {
        procData(data, parsedMessage);
    }
  };

  var old_resp = 0;
  var old_heart = 0;

  const procData = (data, recieveData) => {
    let sampling_rate = recieveData.sampling_rate;
    let ts_range_max = recieveData.bcg_results[0].filtered.length / sampling_rate;
    let ts_range_min = 0;

    if(ts_range_max===22){
      ts_range_min = 12;
    }else{
      if(ts_range_max===12){
        ts_range_min = 2;
      }else{
        ts_range_min = 0;
      }
    }
    let closest_bcg_result = null;
    let min_difference = Infinity;
    let ts_max_time = 0;

    let fsr_sum=recieveData.fsr_sum;
    let resp=recieveData.resp_rate;
    let hr=recieveData.heart_rate;
    let motion_detect=recieveData.motion_detected;

    let apnea_detect=recieveData.apnea_detected;

    if (resp < 9) {
        resp = old_resp;
    } else {
        old_resp = resp;
    }

    if (hr < 56) {
        hr = old_heart;
    } else {
        old_heart = hr;
    }

    // Get the screen width to determine font size
    const screenWidth = window.innerWidth;
    let titleFontSize = 24;  // Default title font size
    let subtitleFontSize = 20;  // Default title font size
    let labelFontSize = 24;  // Default label font size
    let annotationFontSize = 12;  // Default annotation font size
    let annotationOffset = 600;  // Default annotation font size
    // let xaxis_range_from = -1;  // Default annotation font size
    let font_size="font-size:75px;";
    let font_size2="font-size:90px;";
    let font_size3="font-size:20px;";

    graphLayout.xaxis.range=[-1.7, 12.3];
    // Adjust font sizes based on screen width
    if(screenWidth > 1680){

    }else if (screenWidth > 1500) {
        titleFontSize = 26;
        subtitleFontSize = titleFontSize - 10;
        labelFontSize = titleFontSize - 9;
        annotationFontSize = labelFontSize - 8;
        annotationOffset = 300;
        font_size="font-size:65px;";
        font_size2="font-size:85px;";
        // xaxis_range_from = -10.6
    } else if (screenWidth > 1000) {
        titleFontSize = 24;
        subtitleFontSize = titleFontSize - 10;
        labelFontSize = titleFontSize - 6;
        annotationFontSize = labelFontSize - 8;
        annotationOffset = 300;
        font_size="font-size:55px;";
        font_size2="font-size:75px;";
        font_size3="font-size:18px;";
        // xaxis_range_from = -2.5
    } else {
      if (screenWidth <= 1000) {
        font_size="display:none;";
        font_size2="display:none;";
        font_size3="display:none;";
        graphLayout.xaxis.range=[-1.8, 10.5];
      }
        titleFontSize = 22;
        subtitleFontSize = titleFontSize - 10;
        labelFontSize = titleFontSize - 6;
        annotationFontSize = labelFontSize - 8;
        annotationOffset = 300;
        // xaxis_range_from = -2.5
    }

    if(recieveData.bcg_results) {
      let traces = [];
      let peaksTraces = [];
      const respScaleFactor = 4;
      const annotations = [];
      const heartColors = ['#DAA520', "rgb(81, 172, 201)", '#4682B4', '#32CD32', '#8A2BE2', '#2E8B57',];  // 새로운 색상 배열
      const respirationColor = '#00fcff'; // 호흡수 신호는 항상 blue

      let closest_bcg_result_idx = undefined;

      //recieveData에 ecg_result가 있을때만 출력
      if(recieveData.ecg_result){
        recieveData.ecg_result.forEach((ecgResult, i)=>{
            const ts = Array.from({ length: ecgResult.length }, (_, i) => i / sampling_rate);

            const filtered_ts = ts.filter(t => t >= ts_range_min && t <= ts_range_max).map(t => t - ts_range_min);
            let filtered_signal = ecgResult.slice(ts.findIndex(t => t >= ts_range_min), ts.findIndex(t => t > ts_range_max));

            filtered_signal = filtered_signal.map(val => val * 2.5);
            traces.push({
                x: filtered_ts,
                y: filtered_signal.map(val => val + (recieveData.bcg_results.length - i) * offset + 800),
                mode: 'lines',
                line: { color: 'yellow', width: 2 },
                type: 'scattergl'
            });
        });
        annotations.push({
          x: 0.03,  // 오른쪽 끝 위치,
          y: (recieveData.bcg_results.length) * offset + 800,  // 각 신호별로 y축 위치를 다르게 설정
          xref: 'paper',
          yref: 'y',
          text: (
              `<span style="color:yellow;font-size:${labelFontSize}px;"><b>ECG</b></span><br><br/>`
          ),
          showarrow: false,
          font: {
              size: annotationFontSize,
              family: 'Arial',
              color: 'black'
          },
          xanchor: 'left',
        })
      }else{
        graphLayout.yaxis.range=[-1500, 6 * 2800];
      }

      recieveData.bcg_results.forEach((bcgResult, i) => {
          // const ts = bcgResult.ts;  // X축 시간을 초 단위로 변환
          const ts = Array.from({ length: bcgResult.filtered.length }, (_, i) => i / sampling_rate);
          let filteredSignal = bcgResult.filtered;

          const filtered_ts = ts.filter(t => t >= ts_range_min && t <= ts_range_max).map(t => t - ts_range_min);
          let filtered_signal = filteredSignal.slice(ts.findIndex(t => t >= ts_range_min), ts.findIndex(t => t > ts_range_max));

          const ts_length = filtered_ts.length;

          const max_time = ts_length / sampling_rate;  // 100Hz 기준으로 초 단위 변환

          ts_max_time = Math.max(ts_max_time, max_time);  // 최대 시간을 저장

          if (bcgResult.hrv_analysis_data){
              const resultHeartRate = bcgResult.hrv_analysis_data.hr? bcgResult.hrv_analysis_data.hr.toFixed(2) : 0.0;
              if (resultHeartRate !== 0.0){
                  let heart_rate = recieveData.heart_rate ? Math.round(recieveData.heart_rate).toLocaleString('en-US', { minimumIntegerDigits: 3, useGrouping: false }) : 0.0;
                  const difference = Math.abs(resultHeartRate - heart_rate);
                  
                  if (difference < min_difference && bcgResult.jpeaks.length > 3){
                      min_difference = difference;
                      closest_bcg_result = bcgResult;
                      closest_bcg_result_idx = i;
                  }
              }
          }

          let color;
          if (i % 2 === 0) {
              const jpeaks = bcgResult.jpeaks.filter(idx => ts[idx] >= ts_range_min && ts[idx] <= ts_range_max)
                  .map(idx => idx - ts.findIndex(t => t >= ts_range_min));

              color = '#00fc00'
              peaksTraces.push({
                  x: filtered_ts.filter((_, idx) => jpeaks.includes(idx)),
                  y: jpeaks.map(idx => filtered_signal[idx] + (recieveData.bcg_results.length - i - 1) * offset),
                  mode: 'markers+text',
                  text: jpeaks.map((_, idx) => `J${idx}`),
                  textposition: 'top center',
                  type: 'scattergl',
                  marker: { color: "red" }
              });

              // if (bcgResult.gpeaks) {
              //   const gpeaks = bcgResult.gpeaks.filter(idx => ts[idx] >= ts_range_min && ts[idx] <= ts_range_max)
              //       .map(idx => idx - ts.findIndex(t => t >= ts_range_min));

              //   peaksTraces.push({
              //       x: filtered_ts.filter((_, idx) => gpeaks.includes(idx)),
              //       y: gpeaks.map(idx => filtered_signal[idx] + (recieveData.bcg_results.length - i - 1) * offset),
              //       mode: 'markers+text',
              //       text: gpeaks.map((_, idx) => `g${idx}`),
              //       textposition: 'top center',
              //       type: 'scattergl',
              //       marker: { color: "#FF69B4" },
              //       textfont: {
              //         color: '#FF69B4', size: 12
              //       }
              //   });
              // }
              // if (bcgResult.hpeaks) {
              //   const hpeaks = bcgResult.ipeaks.filter(idx => ts[idx] >= ts_range_min && ts[idx] <= ts_range_max)
              //       .map(idx => idx - ts.findIndex(t => t >= ts_range_min));

              //   peaksTraces.push({
              //       x: filtered_ts.filter((_, idx) => hpeaks.includes(idx)),
              //       y: hpeaks.map(idx => filtered_signal[idx] + (recieveData.bcg_results.length - i - 1) * offset),
              //       mode: 'markers+text',
              //       text: hpeaks.map((_, idx) => `h${idx}`),
              //       textposition: 'top center',
              //       type: 'scattergl',
              //       marker: { color: "white" },
              //       textfont: {
              //         color: 'white', size: 12
              //       }
              //   });
              // }
              // if (bcgResult.ipeaks) {
              //   const ipeaks = bcgResult.ipeaks.filter(idx => ts[idx] >= ts_range_min && ts[idx] <= ts_range_max)
              //       .map(idx => idx - ts.findIndex(t => t >= ts_range_min));

              //   peaksTraces.push({
              //       x: filtered_ts.filter((_, idx) => ipeaks.includes(idx)),
              //       y: ipeaks.map(idx => filtered_signal[idx] + (recieveData.bcg_results.length - i - 1) * offset),
              //       mode: 'markers+text',
              //       text: ipeaks.map((_, idx) => `i${idx}`),
              //       textposition: 'top center',
              //       type: 'scattergl',
              //       marker: { color: "#9370DB" },
              //       textfont: {
              //         color: '#9370DB', size: 12
              //       }
              //   });
              // }

              // if (bcgResult.kpeaks) {
              //   const kpeaks = bcgResult.kpeaks.filter(idx => ts[idx] >= ts_range_min && ts[idx] <= ts_range_max)
              //       .map(idx => idx - ts.findIndex(t => t >= ts_range_min));

              //   peaksTraces.push({
              //       x: filtered_ts.filter((_, idx) => kpeaks.includes(idx)),
              //       y: kpeaks.map(idx => filtered_signal[idx] + (recieveData.bcg_results.length - i - 1) * offset),
              //       mode: 'markers+text',
              //       text: kpeaks.map((_, idx) => `k${idx}`),
              //       textposition: 'top center',
              //       type: 'scattergl',
              //       marker: { color: "#00FFFF" },
              //       textfont: {
              //         color: '#00FFFF', size: 12
              //       }
              //   });
              // }

              // if (bcgResult.lpeaks) {
              //   const lpeaks = bcgResult.lpeaks.filter(idx => ts[idx] >= ts_range_min && ts[idx] <= ts_range_max)
              //       .map(idx => idx - ts.findIndex(t => t >= ts_range_min));

              //   peaksTraces.push({
              //       x: filtered_ts.filter((_, idx) => lpeaks.includes(idx)),
              //       y: lpeaks.map(idx => filtered_signal[idx] + (recieveData.bcg_results.length - i - 1) * offset),
              //       mode: 'markers+text',
              //       text: lpeaks.map((_, idx) => `l${idx}`),
              //       textposition: 'top center',
              //       type: 'scattergl',
              //       marker: { color: "white" },
              //       textfont: {
              //         color: 'white', size: 12
              //       }
              //   });
              // }
          } else {
              filtered_signal = filtered_signal.map(val => val * respScaleFactor);
              color = respirationColor
          }

          traces.push({
              x: filtered_ts,
              y: filtered_signal.map(val => val + (recieveData.bcg_results.length - i - 1) * offset),
              mode: 'lines',
              line: { color: color, width: 2 },
              type: 'scattergl'
          });

          if (i % 2 === 0) {
              // RMSSD, SDNN, pNN50 값을 소수점 두 자리로 반올림하여 추출
              const hrvAnalysisData = {
                  median_jj: bcgResult.hrv_analysis_data.median_jj ? bcgResult.hrv_analysis_data.median_jj.toFixed(2) : 'N/A',
                  rmssd: bcgResult.hrv_analysis_data.rmssd ? bcgResult.hrv_analysis_data.rmssd.toFixed(2) : 'N/A',
                  sdnn: bcgResult.hrv_analysis_data.sdnn ? bcgResult.hrv_analysis_data.sdnn.toFixed(2) : 'N/A',
                  pnn50: bcgResult.hrv_analysis_data.pnn50 ? bcgResult.hrv_analysis_data.pnn50.toFixed(2) : 'N/A',
                  sdrr_rmssd_rel_rr: bcgResult.hrv_analysis_data.sdrr_rmssd_rel_rr ? bcgResult.hrv_analysis_data.sdrr_rmssd_rel_rr.toFixed(2) : 'N/A',
                  sd1: bcgResult.hrv_analysis_data.sd1 ? bcgResult.hrv_analysis_data.sd1.toFixed(2) : 'N/A',
                  lf: bcgResult.hrv_analysis_data.lf ? bcgResult.hrv_analysis_data.lf.toFixed(2) : 'N/A',
                  hf: bcgResult.hrv_analysis_data.hf ? bcgResult.hrv_analysis_data.hf.toFixed(2) : 'N/A',
                  lf_hf_ratio: bcgResult.hrv_analysis_data.lf_hf_ratio ? bcgResult.hrv_analysis_data.lf_hf_ratio.toFixed(2) : 'N/A',
                  hr: bcgResult.hrv_analysis_data.hr ? bcgResult.hrv_analysis_data.hr.toFixed(2) : 'N/A',
                  st_lv: bcgResult.hrv_analysis_data.st_lv ? bcgResult.hrv_analysis_data.st_lv.toFixed(3) : 'N/A',
                  baevsky_si: bcgResult.hrv_analysis_data.baevsky_si ? bcgResult.hrv_analysis_data.baevsky_si.toFixed(3) : 'N/A',
              };
              // sendToData.hrv_analysis_data.push(hrvAnalysisData);
              const rmssd = hrvAnalysisData.rmssd;
              const sdnn = hrvAnalysisData.sdnn;
              const pnn50 = hrvAnalysisData.pnn50;
              const hr = hrvAnalysisData.hr;
              const st_lv = hrvAnalysisData.st_lv;
              const heartIndex = Math.floor(i / 2) % heartColors.length;
              let signal_color = heartColors[heartIndex];

              annotations.push({
                  x: 0.01,  // 오른쪽 끝 위치
                  y: (recieveData.bcg_results.length - i - 1) * offset - annotationOffset,  // 각 신호별로 y축 위치를 다르게 설정
                  xref: 'paper',
                  yref: 'y',
                  text: (
                      '<span style="color:' + signal_color + `;font-size:${labelFontSize}px;"><b>BCG ` + (Math.floor(i / 2) + 1) + '</b></span><br><br />' +
                      // '<span style="display:inline-block;text-align:right;color:black;">             HR:       ' + hr + ' bpm</span><br>' +
                      '<span style="display:block;text-align:left;color:#fff;">  ST_LV :        ' + st_lv + '    </span><br>' +
                      '<span style="display:block;text-align:left;color:#fff;"> RMSSD :       ' + rmssd + ' ms</span><br>' +
                      '<span style="display:block;text-align:left;color:#fff;">    SDNN :       ' + sdnn + ' ms</span><br>' +
                      '<span style="display:block;text-align:left;color:#fff;">  pNN50 :       ' + pnn50 + ' % </span>'
                  ),  // 줄바꿈 추가
                  showarrow: false,
                  font: {
                      size: annotationFontSize,
                      family: 'Arial',
                      color: 'black'
                  },
                  xanchor: 'left',
              });
          }
      });

      
      if(fsr_sum<300 || motion_detect===1){
        hr=0;
        resp=0;

        resp=String(resp).padStart(2,0);
        if(motion_detect===1){
          font_size="font-size:60px;";
          fsr_sum="Moving";
        }else{
          fsr_sum=fsr_sum.toFixed(0);
          fsr_sum=String(fsr_sum).padStart(4,0);
        }
      }else{
        hr=hr.toFixed(0);

        if(apnea_detect){
          font_size2="font-size:60px;";
          resp="Apnea";
        }else{
          resp=resp.toFixed(0);
          resp=String(resp).padStart(2,0);
        }

        fsr_sum=fsr_sum.toFixed(0);
        fsr_sum=String(fsr_sum).padStart(4,0);
      }

      if (screenWidth > 1000) {
        annotations.push({
          xref: 'paper',
          yref: 'paper',
          x: 0.835,
          xanchor: 'left',
          y: 0.88,
          yanchor: 'top',
          text: (
              '<span style="color:#00fc00;'+font_size2+'text-align:center;"><b>'+String(hr).padStart(2,0)+'</b></span><br /><br />' +
              '<span style="display:inline-block;text-align:right;color:#00fc00;'+font_size3+'">HR           bpm</span><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />' +
              '<span style="color:#00fcff;'+font_size2+'text-align:center;"><b>'+resp+'</b></span><br /><br />' +
              '<span style="display:inline-block;text-align:right;color:#00fcff;'+font_size3+'">RESP          bpm</span><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />' +
              '<span style="color:#ffff00;'+font_size+'text-align:center;"><b>'+fsr_sum+'</b></span><br /><br />' +
              '<span style="display:inline-block;text-align:right;color:#ffff00;'+font_size3+'">FSR</span>'
              // '<span style="display:inline-block;text-align:right;color:black;">  ST_LV:        ' + st_lv + '    </span><br>' +
              // '<span style="display:inline-block;text-align:right;color:black;"> RMSSD:       ' + rmssd + ' ms</span><br>' +
              // '<span style="display:inline-block;text-align:right;color:black;">    SDNN:       ' + sdnn + ' ms</span><br>' +
              // '<span style="display:inline-block;text-align:right;color:black;">  pNN50:       ' + pnn50 + ' % </span>'
          ),  // 줄바꿈 추가
          showarrow: false,
          font: {
              size: annotationFontSize,
              family: 'Arial',
              color: 'black'
          },
        });
      }

      setGraphData(traces.concat(peaksTraces));
      graphLayout.annotations = annotations;
      setGraphLayout(graphLayout);
    }
  };

  return (
    <Plot
      data={graphData}
      layout={graphLayout}
      style={{ width: "100%", height: "960px" }}
      config={{
        displayModeBar: false,
        displaylogo: false
      }}
    />
  );
};

export default HrvDash;